var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Standart Modül") } },
        [
          _c(
            "a-select",
            {
              model: {
                value: _vm.localValue.module,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "module", $$v)
                },
                expression: "localValue.module",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "contact" } }, [
                _vm._v(_vm._s(_vm.$t("Kişi"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "ticket" } }, [
                _vm._v(_vm._s(_vm.$t("Ticket"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "task" } }, [
                _vm._v(_vm._s(_vm.$t("Görev"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "calendar" } }, [
                _vm._v(_vm._s(_vm.$t("Etkinlik/Rezervasyon"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "email" } }, [
                _vm._v(_vm._s(_vm.$t("E-posta"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-form-item",
        { attrs: { label: _vm.$t("Bağlantı Türü") } },
        [
          _c(
            "a-select",
            {
              on: { change: _vm.handleConnectionTypeChange },
              model: {
                value: _vm.localValue.connectionType,
                callback: function ($$v) {
                  _vm.$set(_vm.localValue, "connectionType", $$v)
                },
                expression: "localValue.connectionType",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "field" } }, [
                _vm._v(_vm._s(_vm.$t("Alan"))),
              ]),
              _vm._v(" "),
              _vm.localValue.module === "contact"
                ? _c(
                    "a-select-option",
                    { attrs: { value: "customProperties" } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Özel Alanlar")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localValue.connectionType === "field"
        ? _c(
            "a-form-item",
            { attrs: { label: _vm.$t("Alan") } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.localValue.field,
                    callback: function ($$v) {
                      _vm.$set(_vm.localValue, "field", $$v)
                    },
                    expression: "localValue.field",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "_id" } }, [
                    _vm._v("ID"),
                  ]),
                  _vm._v(" "),
                  _vm.localValue.module === "contact"
                    ? [
                        _c("a-select-option", { attrs: { value: "name" } }, [
                          _vm._v(_vm._s(_vm.$t("İsim"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "email" } }, [
                          _vm._v(_vm._s(_vm.$t("E-posta"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "phone" } }, [
                          _vm._v(_vm._s(_vm.$t("Telefon"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "whatsappNumber" } },
                          [_vm._v(_vm._s(_vm.$t("WhatsApp Numarası")))]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.localValue.connectionType === "customProperties"
        ? _c(
            "a-form-item",
            { attrs: { label: _vm.$t("Özel Alan") } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.localValue.field,
                    callback: function ($$v) {
                      _vm.$set(_vm.localValue, "field", $$v)
                    },
                    expression: "localValue.field",
                  },
                },
                _vm._l(_vm.contactProperties, function (prop) {
                  return _c(
                    "a-select-option",
                    { key: prop._id, attrs: { value: prop._id } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(prop.label) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }